import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createBlock(_component_el_time_picker, {
    size: _ctx.size,
    "is-range": "",
    "rage-separator": "-",
    format: "HH:mm",
    "disabled-seconds": "",
    clearable: true,
    "popper-class": "time-only-range-picker",
    "start-placeholder": "Начало работ",
    "end-placeholder": "Окончание работ",
    modelValue: _ctx.timePikerModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timePikerModel) = $event)),
    onChange: _ctx.onTimePicked
  }, null, 8, ["size", "modelValue", "onChange"]))
}